import Login from "./login";
import Register from "./register";
import ForgotPassword from "./forgot_password";

export const Auth = {
  Login,
  Register,
  ForgotPassword,
};
